import { buildEventPurchase } from './lizard'

document
  .querySelectorAll('[event-purchase]')
  .forEach(element => element.addEventListener('click', buildEventPurchase))
